import type { ComponentMultiStyleConfig } from '@chakra-ui/theme'

const Tabs: ComponentMultiStyleConfig = {
  parts: ['root', 'tab', 'tablist', 'tabpanel', 'tabpanels', 'indicator'],
  defaultProps: {
    colorScheme: 'brandPrimary',
  },
  variants: {
    enclosed: {
      tab: {
        backgroundColor: '#ffffff',
        borderWidth: 0,
        borderBottom: '2px solid #2F3B4E',
        color: '#2F3B4E',
        fontWeight: 600,
        _selected: {
          backgroundColor: '#2F3B4E',
          color: '#ffffff',
        },
      },
    },
    'soft-rounded': {
      tab: {
        _selected: {
          backgroundColor: '#FED7E2',
          color: '#F94848',
        },
      },
    },
  },
}

export default Tabs
